<div *ngIf="!isOnline" class="offline-message">
  ⚠️ You are offline. Please check your internet connection.
</div>
<router-outlet></router-outlet>